<form class="common-step" [formGroup]="form">
  <tui-multi-select
    tabindex="2"
    formControlName="categories"
    [tuiTextfieldLabelOutside]="true"
    [tuiTextfieldSize]="selectSize"
    [tuiTextfieldCleaner]="true"
    [identityMatcher]="categoryMatcher"
    [rows]="3"
    [stringify]="categoryStringify"
    (searchChange)="onSearchCategories($event)"
  >
    {{ 'components.loyaltyCommonStep.fields.category' | translate }}

    <span class="tui-required"></span>

    <tui-data-list *tuiDataList [size]="optionSize">
      <tui-opt-group *ngFor="let group of categories$ | async" [label]="group.name" tuiMultiSelectGroup>
        <button *ngFor="let item of group.items" tuiOption [value]="item">
          {{ item.name }}
        </button>
      </tui-opt-group>
    </tui-data-list>
  </tui-multi-select>

  <app-search-cities-input tabindex="3" formControlName="cities" [textfieldSize]="selectSize" [textfieldCleaner]="true">
    {{ 'components.loyaltyCommonStep.fields.city' | translate }}
    <span class="tui-required"></span>
  </app-search-cities-input>

  <tui-input tabindex="4" formControlName="name" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
    {{ 'components.loyaltyCommonStep.fields.name' | translate }}

    <input tuiTextfieldLegacy type="text" [placeholder]="'components.loyaltyCommonStep.fields.enterName' | translate" />
    <span class="tui-required"></span>
  </tui-input>

  <tui-textarea
    tabindex="5"
    formControlName="description"
    [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
    [maxLength]="2000"
    [rows]="12"
    [expandable]="true"
  >
    {{ 'components.loyaltyCommonStep.fields.description' | translate }}
    <span class="tui-required"></span>
  </tui-textarea>

  <tui-input tabindex="6" formControlName="descriptionShort" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
    {{ 'components.loyaltyCommonStep.fields.descriptionShort' | translate }}
  </tui-input>

  <tui-input tabindex="7" formControlName="discountText" [tuiTextfieldSize]="isDesktop ? 'l' : 'm'">
    {{ 'components.loyaltyCommonStep.fields.discountText' | translate }}
  </tui-input>

  <tui-input-date
    *ngxPermissionsOnly="['loyaltyProgramDateExpirationFieldEditing']"
    tabindex="8"
    formControlName="dateExpiration"
    [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
  >
    {{ 'components.loyaltyCommonStep.fields.dateExpiration' | translate }}
    <input tuiTextfieldLegacy />
  </tui-input-date>

  <tui-input-number
    *ngxPermissionsOnly="['loyaltyProgramSortOrderEditing']"
    tabindex="9"
    formControlName="sortOrder"
    [tuiNumberFormat]="{ precision: 0 }"
    [min]="0"
    [max]="9999"
    [tuiTextfieldSize]="isDesktop ? 'l' : 'm'"
  >
    {{ 'components.loyaltyCommonStep.fields.sortOrder' | translate }}
  </tui-input-number>

  <div class="common-step__images">
    <span>{{ 'components.loyaltyCommonStep.labels.photos' | translate }} *</span>

    <app-input-files
      tabindex="10"
      formControlName="files"
      [size]="isMobile ? 'm' : 'l'"
      [maxFileSize]="maxFileSize"
      [label]="isMobile ? ' ' : ''"
      [link]="isMobile ? ('components.loyaltyCommonStep.fields.selectFiles' | translate) : ''"
      [accept]="acceptFileMask"
      [multiple]="true"
      [contentTemplate]="coverTmp"
      (rejectedFiles)="rejectedFilesControl.setValue($event)"
    >
      <ng-template #coverTmp let-file>
        <div *ngIf="coverFileName === file?.name" class="common-step__images_cover">
          <tui-icon icon="@tui.check"></tui-icon>

          <span class="text_size-s">{{ 'components.loyaltyCommonStep.labels.cover' | translate }}</span>
        </div>

        <app-link
          *ngIf="coverFileName !== file?.name"
          class="text_size-s"
          [displayText]="'components.loyaltyCommonStep.buttons.setCover' | translate"
          (click)="setCover(file)"
        ></app-link>
      </ng-template>
    </app-input-files>

    <!-- TODO: Вынести в отдельный компонент и использовать его для отображения ошибок на форме -->
    <tui-error *ngIf="filesControl.hasError('required')" [formControl]="filesControl" [error]="filesError"></tui-error>
    <tui-error
      *ngIf="filesControl.hasError('maxLength')"
      [formControl]="filesControl"
      [error]="['maxLength'] | tuiFieldError | async"
    ></tui-error>
    <tui-error
      *ngIf="rejectedFilesControl.hasError('maxLength')"
      [formControl]="rejectedFilesControl"
      [error]="rejectedFilesError"
    ></tui-error>
  </div>
</form>
